<template>
  <div v-loading="loading" class="dialog-edit">
    <!-- 不需要左侧的树结构注释下面即可 -->
    <div class="left-side">
      <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" />
    </div>
    <div class="right-side">
      <el-form ref="productForm" class="filter-form-container" :inline="true" size="mini">
        <el-form-item label="存货分类">
          <el-cascader
            ref="cascader"
            v-model="conditions.classify"
            :options="selectCascaderOptions"
            clearable
            @change="handleCascadeSelectChange"
          />
        </el-form-item>
        <el-form-item label="客户类型">
          <el-select v-model="conditions.type" placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客户编码">
          <el-input v-model="conditions.productName" />
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="conditions.productCode" />
        </el-form-item>
        <el-form-item label="营销单元">
          <el-select v-model="conditions.type" placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <h3>查询结果</h3>
      <div class="btky-container-crud__body">
        <vxe-grid
          ref="gridOptions_12p30g6"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions_12p30g6.gridOptions.columns"
          :data="gridOptions_12p30g6.gridOptions.data"
        >
          <template
            v-if="gridOptions_12p30g6.buttons && gridOptions_12p30g6.buttons.length > 0"
            #form
          >
            <el-form class="form-btns">
              <el-button
                v-for="btn in gridOptions_12p30g6.buttons"
                :key="btn.label"
                @click="tableEvent12p30g6(btn)"
              >{{ btn.label }}</el-button>
            </el-form>
          </template>
          <template v-for="item in gridOptions_12p30g6.gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
              />
              <el-select
                v-else-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'select'"
                v-model="row[item.field]"
                placeholder="请选择"
              >
                <el-option
                  v-for="selectItem in gridOptions_12p30g6.fields.options"
                  :key="selectItem.val"
                  :label="selectItem.label"
                  :value="selectItem.val"
                />
              </el-select>
              <el-switch
                v-else-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'switch'"
                v-model="row[item.field]"
              />
              <el-radio-group
                v-else-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'radio'"
                v-model="row[item.field]"
              >
                <el-radio
                  v-for="selectItem in gridOptions_12p30g6.fields.options"
                  :key="selectItem.val"
                  :label="selectItem.val"
                >{{ selectItem.label }}</el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-else-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'checkbox'"
                v-model="row[item.field]"
              >
                <el-checkbox
                  v-for="selectItem in gridOptions_12p30g6.fields.options"
                  :key="selectItem.val"
                  :label="selectItem.val"
                >{{ selectItem.label }}</el-checkbox>
              </el-checkbox-group>
              <!-- <el-checkbox v-else-if="gridOptions_12p30g6.columnsFieldTypes[item.field] == 'checkbox'" v-model="row[item.field]">备选项</el-checkbox> -->
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </div>
      <!--分页 或底部 自定义底部-->
      <div ref="btkyCrudFooter" class="btky-container-crud__footer">
        <Pagination :pagination="pagination" @pagination-change="handleTablePaginationChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { query } from '@/api/platform/public/productSelect'
// 接口入口
const apiUpdateUserInfo = null
export default {
  props: {
    agents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      agent: {
        key: 0,
        value: ''
      },
      typeOptions: [
        {
          key: 'oper',
          value: '运营商'
        },
        {
          key: 'shop',
          value: '店铺'
        }
      ],
      conditions: {
        classify: '',
        type: 'oper',
        productCode: '',
        productName: ''
      },
      loading: false,
      gridOptions_12p30g6: {
        default_value_type: 'fixed',
        required: false,
        hide_rights: false,
        read_rights: false,
        tableData: 'wlyContractPo',
        mode: 'block',
        buttons: [
          {
            label: '查询',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] },
            is_layout: true,
            funcId: '903342187591237632',
            eventJs: '{\n}\n',
            methodName: 'queryData',
            methodDesc: '查询',
            paramPoList: [
              {
                pk: '',
                name: 'row',
                ip: '192.168.9.34',
                createBy: '1',
                createTime: '2021-10-28 17:59:21',
                updateBy: null,
                updateTime: null,
                tenantId: null,
                dataStatus: null,
                dbType: null,
                id: '903342188765642752',
                eventId: '903342187591237632',
                type: 'in',
                order: null,
                remark: null
              }
            ],
            svrList: {},
            showList: []
          },
          {
            label: '重置',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '新增',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '删除',
            style: 'primary',
            icon: 'cog',
            position: 'all',
            scope: null,
            type: 'custom',
            code: '',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        colspan: 4,
        summary: false,
        sum_text: '',
        summary_method: false,
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            { type: 'checkbox', title: 'id', filed: 'checkbox', width: 120 },
            {
              field: 'name',
              title: '产品名称',
              slots: { default: 'name' },
              editRender: { name: 'input' }
            },
            {
              field: 'code',
              title: '产品编号',
              slots: { default: 'code' },
              editRender: { name: 'input' }
            },
            {
              field: 'cunHuoFenLei',
              title: '存货分类',
              slots: { default: 'cunHuoFenLei' },
              editRender: { name: 'input' }
            },
            {
              field: 'pingPai',
              title: '品牌',
              slots: { default: 'pingPai' },
              editRender: { name: 'input' }
            },
            {
              field: 'guiGeXingHao',
              title: '规格型号',
              slots: { default: 'guiGeXingHao' },
              editRender: { name: 'input' }
            },
            {
              field: 'danWei',
              title: '单位',
              slots: { default: 'danWei' },
              editRender: { name: 'input' }
            }
          ],
          data: [
            { chanPinMingCheng: '五粮液1812', pingPai: '五粮液', danWei: '件' },
            { chanPinMingCheng: '五粮液1818', pingPai: 'sdsd', danWei: '瓶' }
          ],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'chanPinMingCheng',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: {
          default: false,
          cunHuoFenLei: false,
          '': false,
          chuangJianRen: false,
          heTongMingCheng: false
        },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'Y',
        page_size: 20
      },
      treeData: [
        {
          id: 1,
          label: '一级 1',
          children: [
            {
              id: 11,
              label: '二级 1-1',
              children: [
                {
                  id: 111,
                  label: '三级 1-1-1'
                }
              ]
            }
          ]
        },
        {
          label: '一级 2',
          children: [
            {
              label: '二级 2-1',
              children: [
                {
                  label: '三级 2-1-1'
                }
              ]
            },
            {
              label: '二级 2-2',
              children: [
                {
                  label: '三级 2-2-1'
                }
              ]
            }
          ]
        },
        {
          label: '一级 3',
          children: [
            {
              label: '二级 3-1',
              children: [
                {
                  label: '三级 3-1-1'
                }
              ]
            },
            {
              label: '二级 3-2',
              children: [
                {
                  label: '三级 3-2-1'
                }
              ]
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selectCascaderOptions: [
        {
          value: 'zhinan',
          label: '指南',
          children: [
            {
              value: 'yizhi',
              label: '一致'
            }
          ]
        }
      ]
    }
  },
  computed: {},
  created() {},
  methods: {
    // 查询
    handleSearch() {},
    queryData() {
      const formData = new FormData()
      formData.append('productCode', this.conditions.productCode)
      formData.append('productName', this.conditions.productName)
      formData.append('page', '1')
      formData.append('pagesize', '5')
      this.loading = true
      query(formData)
        .then(response => {
          this.loading = false
          console.log(response)
          this.gridOptions_12p30g6.gridOptions.data = response.data.Rows
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    tableEvent12p30g6(btn) {
      switch (btn.label) {
        case '查询':
          this.queryData()
          break
        case '重置':
          this.conditions = {
            type: '',
            productCode: '',
            productName: ''
          }
          break
        case '新增': {
          const data = {
            wlyMakePlanOrderOrderCode: '',
            wlyMakePlanDetailChanPinBianHao: '',
            wlyMakePlanDetailMiaoShu: '',
            wlyMakePlanDetailPinPai: '',
            wlyMakePlanOrderKaiPiaoKeHuName: '',
            wlyMakePlanOrderCreateBy: '',
            wlyMakePlanOrderCreateTime: ''
          }
          this.gridOptions_12p30g6.gridOptions.data.unshift(data)
          this.$refs.gridOptions_12p30g6.insert(data)
          this.$refs.gridOptions_12p30g6.setActiveRow(this.gridOptions_12p30g6.gridOptions.data[0])
          break
        }
        case '编辑':
          this.$refs.gridOptions_12p30g6.setActiveRow(
            this.$refs.gridOptions_12p30g6.getCheckboxRecords()[0]
          )
          break
        case '保存':
          this.$refs.gridOptions_12p30g6.clearActived().then(() => {})
          break
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        // this.$refs['productForm'].validate(async valid => {
        const selectData = this.$refs.gridOptions_12p30g6.getCheckboxRecords()
        resolve(selectData)
        // 表单验证情况
        // if (!valid) return false
        // 参数
        // const params = {}
        // this.loading = true
        // 提交接口请求
        // apiUpdateUserInfo(params)
        //   .then(() => {
        //     this.loading = false
        //     this.$message.success('更新成功')
        //     resolve(true)
        //   })
        //   .catch(() => {
        //     this.loading = false
        //     resolve(false)
        //   })
        // })
      })
    },
    // tree 选中某一节点
    handleNodeClick(data) {
      console.log('handleNodeClick', data)
    },
    // cascadeSelect 选中某一节点
    handleCascadeSelectChange(value) {
      console.log('handleCascadeSelectChange', value)
      // 获取具体选中的子节点信息
      const checkedNodes = this.$refs.cascader.getCheckedNodes(true)
      console.log('getCheckedNodes', checkedNodes)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-edit {
  display: flex;
}
.left-side {
  width: 200px;
  border-right: 1px solid #f5f5f5;
  padding: 8px 10px;
  overflow-y: scroll;
}
.right-side {
  flex: 1;
  .title {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/demo/dialogEdit.vue